// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CvssSecurityRequirementSchema } from '../inputTypeSchemas/CvssSecurityRequirementSchema'
import { CvssModifiedAttackVectorSchema } from '../inputTypeSchemas/CvssModifiedAttackVectorSchema'
import { CvssModifiedAttackComplexitySchema } from '../inputTypeSchemas/CvssModifiedAttackComplexitySchema'
import { CvssModifiedAttackRequirementsSchema } from '../inputTypeSchemas/CvssModifiedAttackRequirementsSchema'
import { CvssModifiedPrivilegesRequiredSchema } from '../inputTypeSchemas/CvssModifiedPrivilegesRequiredSchema'
import { CvssModifiedUserInteractionSchema } from '../inputTypeSchemas/CvssModifiedUserInteractionSchema'
import { CvssModifiedScopeSchema } from '../inputTypeSchemas/CvssModifiedScopeSchema'
import { CvssModifiedImpactSchema } from '../inputTypeSchemas/CvssModifiedImpactSchema'
import { CvssModifiedSubsequentImpactSchema } from '../inputTypeSchemas/CvssModifiedSubsequentImpactSchema'

/////////////////////////////////////////
// CVSS ENVIRONMENTAL REQUIREMENTS SCHEMA
/////////////////////////////////////////

export const CvssEnvironmentalRequirementsSchema = z.object({
  cr: CvssSecurityRequirementSchema,
  ir: CvssSecurityRequirementSchema,
  ar: CvssSecurityRequirementSchema,
  mav: CvssModifiedAttackVectorSchema,
  mac: CvssModifiedAttackComplexitySchema,
  mat: CvssModifiedAttackRequirementsSchema,
  mpr: CvssModifiedPrivilegesRequiredSchema,
  mui: CvssModifiedUserInteractionSchema,
  ms: CvssModifiedScopeSchema,
  mc: CvssModifiedImpactSchema,
  mi: CvssModifiedImpactSchema,
  ma: CvssModifiedImpactSchema,
  mvc: CvssModifiedImpactSchema,
  mvi: CvssModifiedImpactSchema,
  mva: CvssModifiedImpactSchema,
  msc: CvssModifiedImpactSchema,
  msi: CvssModifiedSubsequentImpactSchema,
  msa: CvssModifiedSubsequentImpactSchema,
})

export type CvssEnvironmentalRequirements = z.infer<typeof CvssEnvironmentalRequirementsSchema>

export default CvssEnvironmentalRequirementsSchema;
